/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../components/BaseCom";
import Shop from "../components/Shop";
import { withParamsAndNavigate } from "../components/WithParamsAndNavigate";

class ClientShop extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
    }

    render() {
        return <div className="container">
            <Shop client />
        </div>;
    }
}

export default withParamsAndNavigate(ClientShop);